<script>
  import { link } from "svelte-spa-router";
  import { createEventDispatcher, onMount } from "svelte";
  import axios from "axios";
  import { fade } from "svelte/transition";
  import config from "../../stores/config";
  import * as ls from "local-storage";

  export let orderID = "";
  export let _id = "";
  export let completed;
  export let dateOrdered;
  export let completedOn;
  export let ref;

  const dispatch = createEventDispatcher();

  const handleDelete = () => {
    let confirmDelete = confirm(`Do you wish to delete this Job Card?`);

    if (confirmDelete) {
      axios
        .delete(`${$config.backendURL}/orders/${_id}`, {
          headers: { authorization: ls.get("jwt") },
        })
        .then((res) => {
          dispatch("delete");
        })
        .catch((err) => {
          console.log(err);
          alert(err);
        });
    }
  };
</script>

<div class="hidden bg-red-50" />
<div class="hidden bg-red-100" />

<div
  in:fade={{ duration: $config.f.time() }}
  class="tr border-b border-gray-100"
>
  <div style="min-width: 7.5rem; max-width: 7.5rem;" class="flex items-center">
    <button class="text-base btn btn-red-outline mr-2" on:click={handleDelete}>
      <i class="fas fa-trash" />
    </button>
    <a href={`/orders/${_id}`} use:link class="text-base btn btn-green-outline">
      <i class="fas fa-eye" />
    </a>
  </div>
  <div style="min-width: 8rem; max-width: 8rem;">
    {orderID}
  </div>
  <div style="min-width: 10rem; max-width: 10rem;">
    {new Date(dateOrdered).toDateString() || "N/A"}
  </div>

  <div style="min-width: 7rem; max-width: 7rem;">
    {#if completed}
      <div class="o-pill px-2 py-1 bg-green-200 text-green-700">CLOSED</div>
    {:else}
      <div class="o-pill px-2 py-1 bg-red-200 text-red-700">OPEN</div>
    {/if}
  </div>
  <div style="min-width: 8.5rem; max-width: 8.5rem;">
    {completedOn ? new Date(completedOn).toDateString() : "N/A"}
  </div>
  <div style="min-width: 27.5rem; max-width: 27.5rem;">
    {ref}
  </div>
</div>

<style>
  .tr {
    display: flex;
    align-items: center;
    width: max-content;
    padding: 10px 20px;
  }

  .o-pill {
    display: inline-block;
    border-radius: 9999px;
    font-size: 0.75rem;
    line-height: 1rem;
  }
</style>
